<template>
  <div :class="isMobile?'mobile-top-nav':'top-nav'">
    <div class="back" @click="goBack">
      <img src="@/assets/images/feedback_back.png">
    </div>
    <div class="home" @click="goHome">
      <img src="@/assets/images/feedback_home.png">
    </div>
    <div class="refresh" @click="goRefresh">
      <img src="@/assets/images/feedback_refresh.png">
    </div>
  </div>
</template>

<script>
import {  mapGetters } from 'vuex'

export default {
  name: 'topNav',
  computed: {
    ...mapGetters(['isMobile','feedbackQueryStr'])
  },
  data () {
    return {}
  },
  created () {},
  methods: {
    goBack () {
      this.$router.back(-1)
    },
    goHome () {
      this.$router.push({ path: '/feedback?' + this.feedbackQueryStr })
    },
    goRefresh () {
      location.reload();
      // let query = (location.href).split('/')
      // if (query.length > 3) {
      //   let query3 = (query[3]).split('?')
      //   this.$router.push({ path: '/' + query3[0] + '?'+ query3[1] })
      // }
    }
  }
}
</script>

<style lang="scss">

</style>
